import { render, staticRenderFns } from "./apiariesItem.vue?vue&type=template&id=406b9bd2&"
import script from "./apiariesItem.vue?vue&type=script&lang=js&"
export * from "./apiariesItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports